import { getHotProxyComposeFunction, getReactHOTComposeFunction, } from '../presets';
const componentPanelsPath = '{,*/}%ComponentName%/editor/panels';
export const editorBundlesConfig = {
    parts: true,
    components: true,
    host: true,
};
const panelModelWithHOTPreset = getReactHOTComposeFunction({
    internalPart: 'component',
});
export const editorConventions = {
    patterns: [
        {
            part: 'settingsPanel',
            path: `${componentPanelsPath}/settings/%ComponentName%.settingsPanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'layoutPanel',
            path: `${componentPanelsPath}/layout/%ComponentName%.layoutPanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'behaviorsPanel',
            path: `${componentPanelsPath}/behaviors/%ComponentName%.behaviorsPanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'animationPanel',
            path: `${componentPanelsPath}/animation/%ComponentName%.animationPanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'managePanel',
            path: `${componentPanelsPath}/manage/%ComponentName%.managePanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'backgroundPanel',
            path: `${componentPanelsPath}/background/%ComponentName%.backgroundPanel.tsx`,
        },
        {
            part: 'stylablePanel',
            path: `${componentPanelsPath}/stylable/%ComponentName%.stylablePanel.ts`,
            compose: [getHotProxyComposeFunction()],
        },
        {
            part: 'stylablePanelReact',
            path: `${componentPanelsPath}/stylable/%ComponentName%.stylablePanelReact.tsx`,
            compose: [getReactHOTComposeFunction()],
        },
        {
            part: 'addPanel',
            path: '{,*/}%ComponentName%/editor/%ComponentName%.addPanel.ts',
        },
        {
            part: 'gfpp',
            path: '{,*/}%ComponentName%/editor/%ComponentName%.gfpp.ts',
        },
        {
            part: 'quickEditControl',
            path: '{,*/}%ComponentName%/editor/%ComponentName%.quickEditControl.tsx',
        },
        {
            part: 'metadata',
            path: '{,*/}%ComponentName%/editor/%ComponentName%.editorMetadata.ts',
            compose: [getHotProxyComposeFunction()],
        },
        {
            part: 'translations',
            path: '{,*/}%ComponentName%/editor/%ComponentName%.translations.ts',
        },
        // specific panels
        {
            part: 'devPanel',
            path: `${componentPanelsPath}/dev/%ComponentName%.devPanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'fullscreenPanel',
            path: `${componentPanelsPath}/fullscreen/%ComponentName%.fullscreenPanel.tsx`,
            compose: [panelModelWithHOTPreset],
        },
        {
            part: 'designPanel',
            path: `${componentPanelsPath}/design/%ComponentName%.designPanel.tsx`,
            compose: [getReactHOTComposeFunction()],
        },
    ],
};
//# sourceMappingURL=editor.js.map